module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/6-dda40414e11f776e2cb7ba094f830435.png";